import {
  MACHINES_IN_SERVICE_PERCENTAGE_GET,
  TOP_PRODUCTS_IN_SERVICE_GET,
  DEMANDED_PRODUCTS_GET,
  PERCENTAGE_FILTER_ASC,
  PERCENTAGE_FILTER_DESC,
  DEMAND_FILTER_ASC,
  DEMAND_FILTER_DESC
} from "./mutation-types";
import { loaderDone, loaderStart } from "@/services/LoaderService";
import { errorMessage, showMessage } from "@/services/MessageService";
import { firestore } from "@/config/firebase";
export default {
  async getPercentageMachinesInService({ commit }, branch) {
    loaderStart();
    try {
      const products = (await firestore("dynamic-board")
        .doc("products")
        .get()).data();
      if (branch) {
        let productsData = {
          totalProducts: products.productsTotals[branch]["total"],
          inServiceTotal: products.productsTotals[branch]["inService"]
        };
        commit(MACHINES_IN_SERVICE_PERCENTAGE_GET, productsData);
      } else {
        let productsData = {
          totalProducts: products.totalProducts,
          inServiceTotal: products.productsInService
        };
        commit(MACHINES_IN_SERVICE_PERCENTAGE_GET, productsData);
      }
    } catch (error) {
      errorMessage("Ha ocurrido un error al consultar el porcentaje");
    } finally {
      loaderDone();
    }
  },
  async getTopProductsInService({ commit }, branch) {
    loaderStart();
    try {
      const productsQuerySnapshot = await firestore(
        "dynamic-board/products/items"
      )
        .orderBy("lastUpdate", "desc")
        .limit(1)
        .get();

      if (!productsQuerySnapshot.empty) {
        const latestDocumentDate = productsQuerySnapshot?.docs[0]?.data()
          ?.lastUpdate;
        if (branch) {
          const productItems = await firestore("dynamic-board")
            .doc("products")
            .collection("items")
            .where("venueId", "==", parseInt(branch))
            .where("lastUpdate", "==", latestDocumentDate);
          commit(TOP_PRODUCTS_IN_SERVICE_GET, productItems);
        } else {
          const productItems = await firestore("dynamic-board")
            .doc("products")
            .collection("items")
            .where("lastUpdate", "==", latestDocumentDate);
          commit(TOP_PRODUCTS_IN_SERVICE_GET, productItems);
        }
      } else {
        showMessage({
          message: "No se han encontrado datos de equpos en servicio",
          color: "orange lighten-1"
        });
      }
    } catch (error) {
      errorMessage(
        "Ha ocurrido un error al consultar el top de equipos en servicio"
      );
    } finally {
      loaderDone();
    }
  },
  async getDemandedProducts({ commit }, branch) {
    loaderStart();
    try {
      const branchMap = (await firestore("dynamic-board")
        .doc("commun")
        .get()).data().peopleToProductVenues;
      const productsQuerySnapshot = await firestore(
        "dynamic-board/sale-orders/items-global"
      )
        .orderBy("lastUpdate", "desc")
        .limit(1)
        .get();

      if (!productsQuerySnapshot.empty) {
        const latestDocumentDate = productsQuerySnapshot?.docs[0]?.data()
          ?.lastUpdate;
        if (branch) {
          const productItems = await firestore(
            `dynamic-board/sale-orders/items-${branchMap[branch]}`
          )
            .orderBy("orderCount", "desc")
            .where("lastUpdate", "==", latestDocumentDate);
          commit(DEMANDED_PRODUCTS_GET, productItems);
        } else {
          const productItems = await firestore("dynamic-board")
            .doc("sale-orders")
            .collection("items-global")
            .orderBy("orderCount", "desc")
            .where("lastUpdate", "==", latestDocumentDate);
          commit(DEMANDED_PRODUCTS_GET, productItems);
        }
      } else {
        showMessage({
          message: "No se han encontrado datos de equpos en servicio",
          color: "orange lighten-1"
        });
      }
    } catch (error) {
      console.log(error, "machines");
      errorMessage("Ha ocurrido un error al consultar los equipos demandados");
    } finally {
      loaderDone();
    }
  },
  percentageAsc({ commit }) {
    commit(PERCENTAGE_FILTER_ASC);
  },
  percentageDesc({ commit }) {
    commit(PERCENTAGE_FILTER_DESC);
  },
  demandAsc({ commit }) {
    commit(DEMAND_FILTER_ASC);
  },
  demandDesc({ commit }) {
    commit(DEMAND_FILTER_DESC);
  }
};
